import React from 'react';
import { isIncreasedFlexibilityEnabled } from '@helpcenter/feature-flags';
import { FlexibleHomepageLoader } from '@helpcenter/flexible-homepage-loader';
import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';
import { FlexibleEditpageLoader } from 'view/advanced-help-center/flexible-edit-page-loader';

export const EditCustomPage = withAsync({
	loader: lazyForPaint(
		() => import(/* webpackChunkName: 'async-view-custom-page' */ './edit-custom-page'),
	),
	LoadingSkeleton: () =>
		isIncreasedFlexibilityEnabled() ? (
			<FlexibleEditpageLoader showActionBar />
		) : (
			<FlexibleHomepageLoader showActionBar />
		),
});
